import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { CcRootContext } from "../conversionCenterRoot";
import { getArrayLastItem, sortByPosition } from "../helpers/helpers";
import CcHeader from "../elements/ccHeader";
import CcList from "../elements/ccList";
import CcLinkButton from "../elements/ccLinkButton";

const MainScreen = ({ defaultScreen = null }) => {
  const ctx = useContext(CcRootContext);
  const theme = useTheme();
  const currentFromActiveSite = () => {
    const data = ctx.sites.find((site) => site.active);
    return {
      activeComponentType: data.contentType,
      activeSpecialty: data.specialtyName,
      activeElementPosition: data.welcomeScreenButton.numberInOrder,
      viewId: data.id,
    };
  }
  const current = defaultScreen || getArrayLastItem(ctx.history) || currentFromActiveSite();
  const [mainScreenData, setMainScreenData] = useState(null);
  const [mainScreenElements, setMainScreenElements] = useState(null);
  const [viewReady, setViewReady] = useState(false);
  
  useEffect(() => {
    setMainScreenData(ctx.sites.filter((site) => site.specialtyName === current.activeSpecialty)[0]);
    setViewReady(true);
  }, [ctx.sites, current?.activeSpecialty, defaultScreen]);

  useEffect(() => {
    if (!mainScreenData) return;
    if (!current?.activeSpecialty) return;
    const buttonsList = mainScreenData.elements.map((element) => ({
      btnData: {
        buttonTitle: element.buttonTitle,
        disabled: false,
        disabledOnMobile: false,
        icon: element.iconName,
        numberInOrder: element.numberInOrder,
      },
      speciality: current.activeSpecialty,
      contentType: "elementScreen",
      active: element.active,
      id: element.id,
    }));
    setMainScreenElements(sortByPosition(buttonsList));
  }, [current?.activeSpecialty, mainScreenData]);

  return(
    viewReady && (<>
      {mainScreenData?.active && (
        <>
          <CcHeader 
            details={ mainScreenData.details }
            video={ mainScreenData?.video || { videoUrl: mainScreenData.videoUrl }}
            defaultScreen={defaultScreen}
          />
          {mainScreenElements && (
            <CcList fullwidth={false}>
              {mainScreenElements.filter((el) => el.active).map((data) => <CcLinkButton key={data.speciality} data={data} />)}
            </CcList>
          )}
        </>
      )}
      {!mainScreenData?.active && (
        <strong css={{ color: theme.colors.error }}>No data to display, make sure at least one specialty is active</strong>
      )}
    </>)
  );
};

export default MainScreen;
